import Vue from 'vue'
import vueRouter from 'vue-router'
import NProgress from 'nprogress'
import staticRoutes from './staticRoute'
import whiteRoutes from './whiteRoute'
import { Message } from 'element-ui'
import store from '../store'
import Cookie from 'js-cookie'
import axios from 'axios'
Vue.use(vueRouter)

const router = new vueRouter({
    mode: 'hash',
    routes: staticRoutes
})

const originalPush = vueRouter.prototype.push;
vueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

// 路由跳转前验证
router.beforeEach((to, from, next) => {
    // 开启进度条
    NProgress.start();
    // 判断用户是否处于登录状态
    // console.log('cookieLogin',Cookie.get('loginState'));
    if (Cookie.get('loginState') == 1) {
		let userInfo = JSON.parse(store.state.user.userInfo);
		
        // 如果当前处于登录状态，并且跳转地址为login，则自动跳回系统首页
        // 这种情况出现在手动修改地址栏地址时
        if (to.path === '/login') {
            next({path: "/home", replace: true})
        } else if(to.path.indexOf("/error") >= 0){
            // 防止因重定向到error页面造成beforeEach死循环
            next();
        } 
        next();
    } else {
        // 如果是免登陆的页面则直接进入，否则跳转到登录页面
        if (whiteRoutes.indexOf(to.path) >= 0) {
            console.log('该页面无需登录即可访问')
        } else {
            console.log('当前未处于登录状态，请登录')
            next({path: "/login", replace: true})
        }
		next();
    }
})

router.afterEach((to) => {
	console.log(to.path);
    NProgress.done(); // 结束Progress
})

export default router